/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  GetSchoolHolidaysForDateRangeParams,
  SchoolHolidayDto
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetSchoolHolidaysForDateRangeUrl = (params?: GetSchoolHolidaysForDateRangeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/SchoolHoliday/GetSchoolHolidaysForDateRange?${stringifiedParams}` : `/api/SchoolHoliday/GetSchoolHolidaysForDateRange`
}

export const getSchoolHolidaysForDateRange = async (params?: GetSchoolHolidaysForDateRangeParams, options?: Parameters<typeof customInstance>[1]): Promise<SchoolHolidayDto[]> => {

  return customInstance<SchoolHolidayDto[]>(getGetSchoolHolidaysForDateRangeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSchoolHolidaysForDateRangeQueryKey = (params?: GetSchoolHolidaysForDateRangeParams,) => {
    return [
    `/api/SchoolHoliday/GetSchoolHolidaysForDateRange`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSchoolHolidaysForDateRangeQueryOptions = <TData = Awaited<ReturnType<typeof getSchoolHolidaysForDateRange>>, TError = ErrorType<unknown>>(params?: GetSchoolHolidaysForDateRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchoolHolidaysForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSchoolHolidaysForDateRangeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSchoolHolidaysForDateRange>>> = ({ signal }) => getSchoolHolidaysForDateRange(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSchoolHolidaysForDateRange>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSchoolHolidaysForDateRangeQueryResult = NonNullable<Awaited<ReturnType<typeof getSchoolHolidaysForDateRange>>>
export type GetSchoolHolidaysForDateRangeQueryError = ErrorType<unknown>


export function useGetSchoolHolidaysForDateRange<TData = Awaited<ReturnType<typeof getSchoolHolidaysForDateRange>>, TError = ErrorType<unknown>>(
 params: undefined |  GetSchoolHolidaysForDateRangeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchoolHolidaysForDateRange>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSchoolHolidaysForDateRange>>,
          TError,
          Awaited<ReturnType<typeof getSchoolHolidaysForDateRange>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSchoolHolidaysForDateRange<TData = Awaited<ReturnType<typeof getSchoolHolidaysForDateRange>>, TError = ErrorType<unknown>>(
 params?: GetSchoolHolidaysForDateRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchoolHolidaysForDateRange>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSchoolHolidaysForDateRange>>,
          TError,
          Awaited<ReturnType<typeof getSchoolHolidaysForDateRange>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSchoolHolidaysForDateRange<TData = Awaited<ReturnType<typeof getSchoolHolidaysForDateRange>>, TError = ErrorType<unknown>>(
 params?: GetSchoolHolidaysForDateRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchoolHolidaysForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSchoolHolidaysForDateRange<TData = Awaited<ReturnType<typeof getSchoolHolidaysForDateRange>>, TError = ErrorType<unknown>>(
 params?: GetSchoolHolidaysForDateRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchoolHolidaysForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSchoolHolidaysForDateRangeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSchoolHolidaysForDateRangeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSchoolHolidaysForDateRange>>, TError = ErrorType<unknown>>(params?: GetSchoolHolidaysForDateRangeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSchoolHolidaysForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSchoolHolidaysForDateRangeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSchoolHolidaysForDateRange>>> = ({ signal }) => getSchoolHolidaysForDateRange(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSchoolHolidaysForDateRange>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetSchoolHolidaysForDateRangeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSchoolHolidaysForDateRange>>>
export type GetSchoolHolidaysForDateRangeSuspenseQueryError = ErrorType<unknown>


export function useGetSchoolHolidaysForDateRangeSuspense<TData = Awaited<ReturnType<typeof getSchoolHolidaysForDateRange>>, TError = ErrorType<unknown>>(
 params: undefined |  GetSchoolHolidaysForDateRangeParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSchoolHolidaysForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSchoolHolidaysForDateRangeSuspense<TData = Awaited<ReturnType<typeof getSchoolHolidaysForDateRange>>, TError = ErrorType<unknown>>(
 params?: GetSchoolHolidaysForDateRangeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSchoolHolidaysForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSchoolHolidaysForDateRangeSuspense<TData = Awaited<ReturnType<typeof getSchoolHolidaysForDateRange>>, TError = ErrorType<unknown>>(
 params?: GetSchoolHolidaysForDateRangeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSchoolHolidaysForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSchoolHolidaysForDateRangeSuspense<TData = Awaited<ReturnType<typeof getSchoolHolidaysForDateRange>>, TError = ErrorType<unknown>>(
 params?: GetSchoolHolidaysForDateRangeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSchoolHolidaysForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSchoolHolidaysForDateRangeSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






